import React, { memo, useCallback } from "react";
import { useField, useFormikContext } from "formik";
import { FormHelperText, Typography } from "@mui/material";

import RpWeekPicker from "@/components/muiCustom/date/RpWeekPicker";
import RRDDirectMailToolTips from "../RRDDirectMailToolTips";
import { rrdDirectMailCampaignHelper } from "@/features/campaigns/direct-mail/rrd/utils/rrdDirectMailHelper";

function RRDDirectMailingDateInput({
  name = "mailing_date",
  label = "Select Mailing Date",
  mailingWeeks = [],
  daySlot = undefined,
  minCouponDurationAdmin = undefined,
  lastCouponExpiryDateAdmin = undefined,
  couponExpirationSetBy = undefined,
  fixedCouponDurationDays = undefined,
  frontCouponExpiryDateFieldName = undefined,
  backCouponExpiryDateFieldName = undefined,
}) {
  const { setFieldValue } = useFormikContext();
  const [mailingDateField, , mailingDateHelpers] = useField(name);

  const handleMailingDateChange = useCallback(
    (date) => {
      const expiryDateConstraints =
        couponExpirationSetBy === "brand"
          ? null
          : rrdDirectMailCampaignHelper.getExpiryDateConstraints(
              date,
              minCouponDurationAdmin,
              lastCouponExpiryDateAdmin
            );
      const brandSetExpiryDate =
        couponExpirationSetBy === "brand"
          ? rrdDirectMailCampaignHelper.getBrandSetCouponExpiryDate(
              date,
              fixedCouponDurationDays
            )
          : "";
      const defaultExpiryDate =
        brandSetExpiryDate ||
        expiryDateConstraints?.defaultDate?.format("YYYY-MM-DD") ||
        null;
      mailingDateHelpers.setValue(date ? date : null);

      setFieldValue(frontCouponExpiryDateFieldName, defaultExpiryDate);
      setFieldValue(backCouponExpiryDateFieldName, defaultExpiryDate);
    },
    [
      couponExpirationSetBy,
      fixedCouponDurationDays,
      mailingDateHelpers,
      minCouponDurationAdmin,
      lastCouponExpiryDateAdmin,
      frontCouponExpiryDateFieldName,
      backCouponExpiryDateFieldName,
      setFieldValue,
    ]
  );

  return (
    <>
      <Typography
        variant="body2"
        className="mb-2"
        gutterBottom
        fontWeight={600}
      >
        {label} <RRDDirectMailToolTips type="mailing_date" />
      </Typography>
      <div className="rrd-mailing-date-input">
        <RpWeekPicker
          name={name}
          value={mailingDateField.value || null}
          onChange={handleMailingDateChange}
          highlightWeekDaysOnly
          enableWeeks={mailingWeeks}
          disabled={!mailingWeeks?.length}
          useDefaultCalendarIcon
          slots={{ day: daySlot }}
          inputAlign="left"
        />
        {!mailingWeeks?.length ? (
          <FormHelperText sx={{ color: "error.main" }}>
            Mailing weeks are not available
          </FormHelperText>
        ) : null}
      </div>
    </>
  );
}

export default memo(RRDDirectMailingDateInput);
